import { auth } from './firebase';

/**
 * Authenticated fetch wrapper.
 * Automatically attaches the Firebase ID token as a Bearer token.
 */
export async function apiFetch(
  url: string,
  options?: RequestInit
): Promise<Response> {
  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : null;
  const headers = new Headers(options?.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(url, { ...options, headers });
}
